<template>
  <v-container fluid class="container-view">
    <period-selector
      v-if="showPeriodSelector"
      :year="selectedYear"
      :month="selectedMonth"
      @update:year="selectedYear = $event"
      @update:month="selectedMonth = $event"
      @period-changed="onPeriodChanged"
    ></period-selector>

    <div class="d-flex flex-row tabs-container">
      <v-tabs v-model="tab" color="#ffb500" direction="vertical">
        <v-tab
          :prepend-icon="mdiChartBar"
          text="Statistiques"
          value="statistics"
        ></v-tab>
        <v-tab
          :prepend-icon="mdiHomeGroup"
          text="Divisions"
          value="divisions"
        ></v-tab>
        <v-tab
          :prepend-icon="mdiAccountGroup"
          text="Clients"
          value="clients"
        ></v-tab>
        <v-tab
          :prepend-icon="mdiPackageVariant"
          text="Commandes One Stryker"
          value="orderOneStryker"
        ></v-tab>
        <v-tab
          :prepend-icon="mdiTextBoxOutline"
          text="Provisions"
          value="provisions"
        ></v-tab>
        <v-tab
          :prepend-icon="mdiAccountFileText"
          text="Commissions"
          value="commissions"
        ></v-tab>
        <v-tab
          :prepend-icon="mdiHistory"
          text="Historique KPI"
          value="historique"
        ></v-tab>
      </v-tabs>

      <v-tabs-window v-model="tab" class="flex-grow-1">
        <v-tabs-window-item value="statistics" class="full-height-tab">
          <statistic-kpi
            :statistics="statistics"
            :statisticsSecondPart="statisticsSecondPart"
          ></statistic-kpi>
        </v-tabs-window-item>
        <v-tabs-window-item value="divisions" class="full-height-tab">
          <franchise-kpi
            :chartOptions="chartOptions"
            :series="series"
            :selectedYear="{ text: String(selectedYear), value: selectedYear }"
            :selectedMonth="selectedMonth"
          ></franchise-kpi>
        </v-tabs-window-item>
        <v-tabs-window-item value="clients" class="full-height-tab">
          <customer-kpi
            :selectedYear="selectedYear"
            :selectedMonth="selectedMonth"
          ></customer-kpi>
        </v-tabs-window-item>
        <v-tabs-window-item value="orderOneStryker" class="full-height-tab">
          <order-one-stryker-kpi></order-one-stryker-kpi>
        </v-tabs-window-item>
        <v-tabs-window-item value="provisions" class="full-height-tab">
          <cogs-kpi></cogs-kpi>
        </v-tabs-window-item>
        <v-tabs-window-item value="commissions" class="full-height-tab">
          <commissions-kpi></commissions-kpi>
        </v-tabs-window-item>
        <v-tabs-window-item value="historique" class="full-height-tab">
          <kpi-history-admin></kpi-history-admin>
        </v-tabs-window-item>
      </v-tabs-window>
    </div>
  </v-container>
</template>

<script>
import StatisticKpi from "@/components/kpi/StatisticKpi.vue";
import FranchiseKpi from "@/components/kpi/FranchiseKpi.vue";
import CustomerKpi from "@/components/kpi/CustomerKpi.vue";
import OrderOneStrykerKpi from "@/components/kpi/OrderOneStrykerKpi.vue";
import CogsKpi from "@/components/kpi/CogsKpi.vue";
import CommissionsKpi from "@/components/kpi/CommissionsKpi.vue";
import PeriodSelector from "@/components/kpi/PeriodSelector.vue";
import KpiHistoryAdmin from "@/components/kpi/KpiHistoryAdmin.vue";
import contractYear from "@/mixins/contractYear";
import { mapState } from "vuex";
import {
  mdiChartBar,
  mdiHomeGroup,
  mdiAccountGroup,
  mdiPackageVariant,
  mdiTextBoxOutline,
  mdiAccountFileText,
  mdiHistory,
} from "@mdi/js";

export default {
  name: "KPIView",
  mixins: [contractYear],
  components: {
    StatisticKpi,
    FranchiseKpi,
    CustomerKpi,
    OrderOneStrykerKpi,
    CogsKpi,
    CommissionsKpi,
    PeriodSelector,
    KpiHistoryAdmin,
  },
  data() {
    // Calcul de l'année contractuelle pour l'initialisation
    const now = new Date();
    const year = now.getFullYear();
    const month = now.getMonth() + 1;
    const day = now.getDate();
    const initialYear = month === 1 && day <= 15 ? year - 1 : year;

    return {
      mdiChartBar,
      mdiAccountGroup,
      mdiHomeGroup,
      mdiPackageVariant,
      mdiTextBoxOutline,
      mdiAccountFileText,
      mdiHistory,
      tab: "statistics",
      selectedYear: initialYear,
      selectedMonth: null,
    };
  },
  mounted() {
    this.$store.dispatch("kpi/fetchHistorizedPeriods");
  },
  watch: {
    tab(newTab) {
      this.loadTabData(newTab);
    },
  },
  methods: {
    /**
     * Gère le changement de période
     */
    onPeriodChanged({ year, month }) {
      this.selectedYear = year;
      this.selectedMonth = month;
      this.$store.commit("kpi/setSelectedYear", year);
      this.$store.commit("kpi/setSelectedMonth", month);
      this.loadTabData(this.tab);
    },
    /**
     * Charge les données pour l'onglet actif
     */
    loadTabData(tabName) {
      this.$store.commit("setOverlay", true);
      let action = "";
      let params = null;

      if (tabName === "statistics") {
        action = "kpi/fetchStatistics";
        params = { year: this.selectedYear, month: this.selectedMonth };
      } else if (tabName === "divisions") {
        action = "kpi/fetchFranchiseStatistics";
        params = { year: this.selectedYear, month: this.selectedMonth };
      } else if (tabName === "clients") {
        action = "kpi/fetchCustomersStatistics";
        params = { year: this.selectedYear, month: this.selectedMonth };
      } else if (tabName === "orderOneStryker") {
        action = "kpi/fetchOrderOneStrykerStatistics";
        params = null;
      } else if (tabName === "provisions") {
        action = "kpi/fetchKPIProvisions";
        params = { year: this.selectedYear, month: this.selectedMonth };
      } else if (tabName === "commissions") {
        action = "kpi/fetchKPICommissions";
        params = null;
      }

      if (action !== "") {
        this.$store
          .dispatch(action, params)
          .then((response) => {
            if (action === "kpi/fetchOrderOneStrykerStatistics") {
              this.$store.commit(
                "paginations/setItems",
                JSON.parse(response.headers.get("X-Pagination")),
              );
            }
            this.$store.commit("setOverlay", false);
          })
          .catch(() => {
            this.$store.commit("setOverlay", false);
          });
      } else {
        this.$store.commit("setOverlay", false);
      }
    },
  },
  computed: {
    ...mapState({
      statistics: (state) => state.kpi.statistics,
      statisticsSecondPart: (state) => state.kpi.statisticsSecondPart,
      statisticsItems: (state) => state.kpi.statisticsItems,
    }),
    /**
     * Détermine si le sélecteur de période doit être affiché
     */
    showPeriodSelector() {
      return ["statistics", "divisions", "clients", "provisions"].includes(
        this.tab,
      );
    },
    /**
     * Données triées par ordre décroissant pour le graphique
     */
    sortedStatisticsItems() {
      return [...this.statisticsItems].sort(
        (a, b) => b.totalPoints - a.totalPoints,
      );
    },
    series() {
      return [
        {
          name: "Commandes en points",
          data: this.sortedStatisticsItems.map((item) => item.totalPoints),
        },
      ];
    },
    categories() {
      return this.sortedStatisticsItems.map((item) => item.franchise.name);
    },
    chartOptions() {
      const colors = [
        "#fec210",
        "#abafae",
        "#b67318",
        "#7e4594",
        "#00548b",
        "#277a7f",
      ];

      return {
        chart: {
          height: 650,
          type: "bar",
          events: {
            click: () => {
              // Gérer l'événement de clic ici
            },
          },
        },
        colors: colors,
        plotOptions: {
          bar: {
            columnWidth: "50%",
            distributed: true,
          },
        },
        dataLabels: {
          enabled: false,
        },
        legend: {
          show: false,
        },
        grid: {
          row: {
            colors: ["#fff"],
          },
        },
        xaxis: {
          labels: {
            style: {
              fontSize: "12px",
            },
          },
          categories: this.categories,
          tickPlacement: "on",
        },
        yaxis: {
          title: {
            text: "Commandes en points",
          },
        },
      };
    },
  },
};
</script>

<style scoped>
.tabs-container {
  width: 100%;
}

.flex-grow-1 {
  flex-grow: 1;
  width: 100%;
}
</style>
